<template>
    <div id="delete-client" class="modal inmodal fade" role="dialog" aria-hidden="true" data-backdrop="static" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content animated fadeInUp">
                <div class="modal-header">
                    <h2 class="modal-title">{{ t_deleteclient }}</h2>
                </div>
                <div class="modal-body text-center scrollBox" :style="'max-height: ' + maxBodyHeight + 'px;'">
                    <h2 v-if="clientNames.length > 0" class="clientname">{{ clientNames.join(", ") }}</h2>
                </div>
                <div class="modal-footer">
                    <v-btn type="button" class="btn btn-secondary" data-dismiss="modal">
                        {{ t_cancel }}
                    </v-btn>
                    <v-btn type="button" class="btn btn-primary submit" @click.stop.prevent="deleteClient">
                        {{ t_delete }}
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import modalMixin from "../../common/modal-mixin";
    import toaster from "../../common/toaster";

    export default {
        mixins: [
            modalMixin,
        ],
        data: function () {
            return {
                t_close: Lang.langGet("Close"),
                t_deleteclient: Lang.langGet("Delete selected clients"),
                t_cancel: Lang.langGet("Cancel"),
                t_delete: Lang.langGet("Delete"),
                t_delete_success: Lang.langGet("Clients deleted successfully."),
                t_delete_fail: Lang.langGet("Failed to delete clients."),
                clientNames: [],
                clientIDs: [],

                modalName: 'delete-client',
            }
        },
        methods: {
            reset: function () {
                _.extend(this.$data, this.$options.data());
            },
            deleteClient: function () {
                axios.post('/administration/client/delete', {
                    ids: this.clientIDs
                }).then(() => {
                    toaster.success(this.t_delete_success);
                    EaseEventBus.fire('updateClientList');
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_delete_fail);
                });

                EaseEventBus.fire('hideModal', this.modalName);
            }
        },
        mounted() {
            EaseEventBus.listen('clientDelete', (data) => {
                this.reset();
                this.clientNames = data.names;
                this.clientIDs = data.ids;
                EaseEventBus.fire('showModal', this.modalName);

                this.$nextTick(() => {
                    this.calcModalHeight();
                });
            });

            EaseEventBus.listen('hideModal', (modal) => {
                if (modal === this.modalName) {
                    this.reset();
                }
            });
        }
    }
</script>
